import { render, staticRenderFns } from "./TagCreateView.vue?vue&type=template&id=0d89b6aa"
import script from "./TagCreateView.vue?vue&type=script&lang=js"
export * from "./TagCreateView.vue?vue&type=script&lang=js"
import style0 from "./TagCreateView.vue?vue&type=style&index=0&id=0d89b6aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports